import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import styled from 'styled-components'
import { ProductCard } from './products/ProductCard'
import { Pagination } from './products/product_page/Pagination'

const Container = styled.div`
    max-width: 1920px;
    margin: 0 auto;
    padding: 5rem 2rem;

    .result-output {
        display: flex;
        flex-wrap: wrap;

        @media (max-width: 959.98px) {
            display: flex;
            flex-direction: column;
            align-items: center;
        }
    }
    .title,
    .subtitle {
        font-family: 'SF UI Text', sans-serif;
        font-weight: 400;
        font-size: 3.75rem;
        line-height: 160%;
        
        @media (min-width: 768px) {
            margin-left: 40px;
        }
    }
    .subtitle {
        font-size: 2.75rem;
        margin-bottom: 5rem;
        
        @media (min-width: 768px) {
            margin-left: 40px;
        }
    }
    .pagination {
        margin: 0 auto;
    }

`

export const SearchingPage = () => {

    const search_result = useSelector(state => state.searching.result)

    const [currentPage, setCurrentPage] = useState(1)
    const productsPerPage = 10

    const indexOfLastProduct = currentPage * productsPerPage
    const indexOfFirstProduct = indexOfLastProduct - productsPerPage

    return (
        <Container>

            <p className='title'>Поиск продукции</p>
            { search_result.length !== 0 && search_result[0] !== 'not_found'
                ? <p className='subtitle'>Найдено продуктов: {search_result.length}</p>
                : search_result[0] === 'not_found'
                    ? <p className='subtitle' >По вашему запросу ничего не найдено :( </p>
                    : null
            }

            <div className="result-output">
                {search_result.length !== 0 && search_result[0] !== 'not_found'
                    ? search_result.slice(indexOfFirstProduct, indexOfLastProduct).map(item => (
                        <ProductCard
                            product_data={item}
                            key={item.key}
                        />))
                    : null
                }
            </div>

            {search_result.length > productsPerPage
                ? <Pagination
                    productsPerPage={productsPerPage}
                    totalProducts={search_result.length}
                    paginate={(pageNumber) => setCurrentPage(pageNumber)}
                    currentPage={currentPage}
                />
                : null
            }

        </Container>
    )
}
